import { ChangeEvent, FC, useEffect, useState } from 'react';

interface RegisterTermsProps {
  termFile: string; //ex) neospectra_terms.html (sample1.pdf일 경우 sample1.html로 생성)
  termTitle: string; //ex) 심메타 클라우드 서비스 약관동의
  serviceTerm: boolean;
  handleTermChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const RegisterTerms: FC<RegisterTermsProps> = ({
    termFile,
    termTitle,
    serviceTerm,
    handleTermChange,
}) => {
  const [html, setHtml] = useState('');
  const [htmlInfo, setHtmlInfo] = useState('');
  const [termAgree1, setTermAgree1] = useState(false); // 첫번째 약관
  const [termAgree2, setTermAgree2] = useState(true); // 개인정보 수집 약관

  useEffect(() => {
    //props에 명시된 html 파일 경로 ('public/ 하위') 읽어와서 초기화
    fetch(`/${termFile}`)
      .then(res => res.text())
      .then(setHtml)
      .catch(console.error);
    
    setTermAgree1(serviceTerm);
    
    if(termTitle === '지오닉 클라우드 서비스 약관동의'){
      setTermAgree2(serviceTerm);
      fetch(`/infoseed_info.html`)
      .then(res => res.text())
      .then(setHtmlInfo)
      .catch(console.error);
    }
  }, [termFile]);

  useEffect(() => {
    // 두 항목 모두 동의 시만 true 전달
    const finalAgree = termAgree1 && (htmlInfo ? termAgree2 : true);

  }, [termAgree1, termAgree2, htmlInfo]);

  const handleChange1 = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value === 'true';
    const finalAgree = newValue && (htmlInfo ? termAgree2 : true);
    setTermAgree1(newValue);
    if (finalAgree) {
      handleTermChange(e); // 여기서 e는 올바른 이벤트 객체
    }else if(!newValue){
      handleTermChange(e); // 여기서 e는 올바른 이벤트 객체
    }
  };

  const handleChange2 = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value === 'true';
    const finalAgree = termAgree1 && (htmlInfo ? newValue : true);
    setTermAgree2(newValue);
    if (finalAgree) {
      handleTermChange(e);
    }else if(!newValue){
      handleTermChange(e); // 여기서 e는 올바른 이벤트 객체
    }
  };

  return (
    <div
      className="regi-terms"
      style={{
        margin: '2rem 0',
        padding: '3rem',
        border: '1px solid #bdbdbd',
        borderRadius: '1rem',
      }}
    >
      <div className="rows">
        <div className="consent-title">
          <em className="color-red">[필수]</em> {termTitle}
        </div>
        <div className="consent-con">
          {/* html 파일 import */}
          <div dangerouslySetInnerHTML={{ __html: html }} /> 
        </div>
      </div>
      <div className="consent-actions">
        <div className="consent-desc">
          서비스 약관동의에 대한 안내 사항을 읽고 동의합니다.
        </div>
        <div className="consent-check">
          <label className="label-radio">
            <input
              type="radio"
              name="serviceTerms"
              value="false"
              checked={!termAgree1}
              onChange={handleChange1}
            />
            <i></i>동의하지 않음
          </label>
          <label className="label-radio">
            <input
              type="radio"
              name="serviceTerms"
              value="true"
              checked={termAgree1}
              onChange={handleChange1}
            />
            <i></i> 동의함
          </label>
        </div>
      </div>
      <br></br>
      {htmlInfo && (
        <>
        <div className="rows">
          <div className="consent-title">
            <em className="color-red">[필수]</em> {'지오닉 클라우드 서비스 개인정보 수집 및 이용동의'}
          </div>
          <div className="consent-con">
            {/* html 파일 import */}
            <div dangerouslySetInnerHTML={{ __html: htmlInfo }} /> 
          </div>
        </div>
        <div className="consent-actions">
          <div className="consent-desc">
          개인정보 수집 및 이용동의에 대한 안내 사항을 읽고 동의합니다.
          </div>
          <div className="consent-check">
            <label className="label-radio">
              <input
                type="radio"
                name="infoTerms"
                value="false"
                checked={!termAgree2}
                onChange={handleChange2}
              />
              <i></i>동의하지 않음
            </label>
            <label className="label-radio">
              <input
                type="radio"
                name="infoTerms"
                value="true"
                checked={termAgree2}
                onChange={handleChange2}
              />
              <i></i> 동의함
            </label>
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default RegisterTerms;
